import React, { useEffect, useState } from 'react';
import API_BASE_URL from '../../config/api';

// Only the read-only local snapshot server supplies this endpoint. This
// control is never shown in a production build or for a real manager account.
export default function LocalProjectPreviewPicker({ enabled, buildingId }) {
  const [buildings, setBuildings] = useState([]);
  useEffect(() => {
    if (!enabled) return;
    let cancelled = false;
    fetch(`${API_BASE_URL}/api/localProjectPreviewBuildings`, {
      headers: { Authorization: `Bearer ${localStorage.getItem('managerToken')}` },
    }).then(response => response.ok ? response.json() : null)
      .then(data => { if (!cancelled) setBuildings(data?.buildings || []); })
      .catch(() => {});
    return () => { cancelled = true; };
  }, [enabled]);
  if (!enabled || !buildings.length) return null;
  const selected = buildings.find(building => String(building.buildingId) === String(buildingId));
  return <div style={{ width: '90%', margin: '1rem auto', padding: '12px 16px', background: '#edf4ff', borderRadius: 8 }}>
    <div style={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap', gap: 12 }}>
      <label htmlFor="local-project-building" style={{ margin: 0 }}>Local preview · Building</label>
      <select id="local-project-building" className="form-select" style={{ width: 'auto', maxWidth: '100%' }}
        value={buildingId} onChange={event => { window.location.href = `/?localProjectBuilding=${encodeURIComponent(event.target.value)}`; }}>
        {buildings.map(building => <option key={building.buildingId} value={building.buildingId}>{building.name}</option>)}
      </select>
    </div>
    {selected?.hasProjectCycle === false && <div style={{ marginTop: 8 }}>
      No Project cycle is on file for this building. Showing its existing maintenance dashboard.
    </div>}
  </div>;
}
